<template>
  <el-dialog
    :close-on-click-modal="false"
    title="选择物流方式"
    :visible.sync="visible"
    width="800px"
    top="10vh"
    class="relateOrder"
    :before-close="handleClose"
    @row-click="itemsRowClick"
  >
    <div style="max-height: 69vh; overflow: auto">
      <div class="table">
        <div
          v-if="orderData.appNo"
          style="display: flex; line-height: 28px; font-size: 14px"
        >
          <div style="flex: 1">订单号： {{ orderData.appNo }}</div>
          <div
            v-if="
              tableData && tableData.length > 1 && tableData[0].total_weight
            "
            style="flex: 1"
          >
            重量：{{
              tableData.length > 0 ? tableData[0].total_weight + "g" : ""
            }}
          </div>
        </div>

        <div
          v-if="orderData.appNo"
          style="
            display: flex;
            line-height: 28px;
            margin: 0 0 8px 0;
            font-size: 14px;
          "
        >
          <div style="flex: 1">
            收件国家：{{
              dictMap["amazon_site"][orderData.addr ? orderData.addr.state : ""]
            }}
          </div>
          <div style="flex: 1">
            收件人： {{ orderData.addr ? orderData.addr.receName : "" }}
          </div>
        </div>
        <div class="table-list">
          <el-table
            :data="tableData"
            class="border"
            header-cell-class-name="table-header"
            style="width: 100%"
            highlight-current-row
            @current-change="handleCurrentChange"
            @row-click="itemsRowClick"
          >
            <el-table-column label="" class="tableColumnClass">
              <template slot-scope="scope" class="radio"
                ><el-radio v-model="radioId" :label="scope.row.shipping_method"
                  >&nbsp;</el-radio
                ></template
              >
            </el-table-column>
            <el-table-column prop="shipping_method_name" label="物流方式">
            </el-table-column>
            <el-table-column prop="shipping_fee" label="物流费用">
              <template slot-scope="scope">
                <el-popover
                  v-if="scope.row.shipping_fee"
                  ref="popover1"
                  placement="top-start"
                  title="物流价格说明"
                  trigger="hover"
                  width="800"
                >
                  <div style="overflow: auto" class="weight">
                    <div>计费重量 {{ scope.row.total_weight }}克</div>
                    <div v-if="scope.row.detail">
                      物流费用={{ getFormula(scope.row) }}
                    </div>
                    <div v-else>物流费用={{ scope.row.formula_value }}</div>
                    <table
                      v-if="scope.row.detail"
                      class="ship"
                      style="border-collapse: collapse"
                    >
                      <tr>
                        <td>首重价格</td>
                        <td>首重重量</td>
                        <td>续重单位重量</td>
                        <td>续重单位价格</td>
                        <td>操作费</td>
                      </tr>
                      <tr>
                        <td>{{ scope.row.detail.firstPrice }}</td>
                        <td>{{ scope.row.detail.firstWeight }}</td>
                        <td>{{ scope.row.detail.contWeight }}</td>
                        <td>{{ scope.row.detail.contPrice }}</td>
                        <td>{{ scope.row.detail.operCost }}</td>
                      </tr>
                    </table>

                    <table
                      v-else
                      class="ship"
                      style="border-collapse: collapse"
                    >
                      <tr>
                        <td>重量区间</td>
                        <td :key="key" v-for="(value, key) in scope.row.prices">
                          {{ value.weight }}
                        </td>
                      </tr>
                      <tr>
                        <td>价格</td>
                        <td :key="key" v-for="(value, key) in scope.row.prices">
                          {{ value.price }}
                        </td>
                      </tr>
                      <tr>
                        <td>固定附加费</td>
                        <td :key="key" v-for="(value, key) in scope.row.prices">
                          {{ value.fee }}
                        </td>
                      </tr>
                    </table>

                    <div>
                      <div>计算公式：{{ scope.row.formula_value }}</div>
                      <div v-if="scope.row.detail">
                        物流费用=[首重价格+⌈(计费重量-首重重量)/续重单位重量⌉*续重单位价格]+操作费<br />
                        注：(计费重量-首重)/续重单位重量，结果需向上取整；公式中的“⌈
                        ⌉”为向上取整符号
                      </div>
                      <div v-else>
                        物流费用={{
                          scope.row.formula_explain_zh
                            ? scope.row.formula_explain_zh
                            : scope.row.detail
                            ? scope.row.detail.referTime
                            : ""
                        }}
                      </div>
                    </div>
                  </div>
                  <div slot="reference">
                    ￥{{ scope.row.shipping_fee }} <i class="el-icon-info"></i>
                  </div>
                </el-popover>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="delivery_range" label="参考时限">
              <template slot-scope="scope" class="radio">
                <span v-if="scope.row.delivery_range">{{
                  scope.row.delivery_range
                }}</span>
                <span v-else>{{
                  scope.row.detail ? scope.row.detail.referTime : "-"
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取消</el-button>
      <el-button type="primary" @click="handleSave" size="small">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getOrderShip, editExpre } from "@/api/order/all"
import SelectShip from "./SelectShip"
import { mapGetters } from "vuex"

export default {
  name: "SelectShip",
  data() {
    return {
      tableData: [],
      currentShip: {},
      logisticsDescriptionData: [],
      radioId: "",
    }
  },
  components: {
    SelectShip,
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    orderData: {
      type: Object,
      default() {
        return {}
      },
    },
    appIds: {
      type: String,
      default() {
        return ""
      },
    },
    trackingNumbers: {
      type: String,
      default() {
        return ""
      },
    },
  },
  watch: {
    visible: {
      async handler() {
        if (this.visible) {
          let _self = this
          let appId = this.orderData.appId
          if (!appId) {
            appId = this.appIds.split(",")[0]
          }

          let result = await getOrderShip({ appId: appId })
          this.radioId = ""
          this.currentShip = null

          result.data.map((record) => {
            if (!record.total_weight) {
              record.total_weight = 0
              record.formula_value = 0
              record.shipping_fee = 0
            }
          })
          for (let record of result.data) {
            let prices = []
            for (let key in record.prices) {
              let object = {
                firstWeight: 0,
                weight: 0,
                price: 0,
                fee: 0,
              }
              let priceArray = record.prices[key].split(":")
              object.weight = key
              if (priceArray.length > 0) {
                object.price = Number(priceArray[0])
              }
              if (priceArray.length > 1) {
                object.fee = priceArray[1]
              }
              object.firstWeight = Number(key.split("-")[0])
              prices.push(object)
            }
            prices = _self._.sortBy(prices, function(item) {
              return Number(item.firstWeight)
            })
            record.prices = prices
          }
          this.tableData = result.data
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  methods: {
    itemsRowClick(row) {
      this.radioId = row.shipping_method
    },
    async handleSave() {
      if (!this.currentShip) {
        this.msgError("请选择物流")
        return
      }
      let params = [
        {
          shippingMethod: this.currentShip.shipping_method,
          appId: this.orderData.appId,
          proFare: this.currentShip.shipping_fee,
        },
      ]
      if (this.orderData.trackingNumber) {
        params[0].trackingNumber = this.orderData.trackingNumber
      }
      if (!this.orderData.appId) {
        let appArray = this.appIds.split(",")
        let trackingNumberArray = this.trackingNumbers.split(",")
        params = []
        for (let i = 0; i< appArray.length;i++) {
          params.push({
            shippingMethod: this.currentShip.shipping_method,
            appId: appArray[i],
            trackingNumber: trackingNumberArray[i],
            proFare: this.currentShip.shipping_fee,
          })
        }
      }

      try {
        let result = await editExpre(params)
        this.msgSuccess("设置成功")
        this.$emit("onClose")
      } catch (error) {}
    },
    handleClose() {
      this.$emit("onClose")
    },
    async handleCurrentChange(row) {
      this.currentShip = row
    },
    getFormula(ship) {
      let weight = ship.total_weight
      if (weight > ship.detail.firstWeight) {
        return `${ship.detail.firstPrice}+⌈(${weight}-${ship.detail.firstWeight})/${ship.detail.contWeight}⌉*${ship.detail.contPrice}+${ship.detail.operCost}`
      } else {
        return `${ship.detail.firstPrice}+${ship.detail.operCost}`
      }
    },
  },
}
</script>

<style scoped lang="scss">
.pd10 {
  padding: 5px 10px;
  border-top: 1px solid #ebeef5;
}

.relateOrder {
  font-size: 12px;
}

.relateOrder .line {
  display: flex;
  height: 30px;
  align-items: center;
}

.relateOrder .line .title {
  width: 60px;
}

.table {
}

.table .top {
  display: flex;
  background: #f5f7fa;
  height: 36px;
  align-items: center;
}

.table .top .item {
  width: 50%;
  display: flex;
}

.table .top .item .left {
  width: 50px;
  text-align: center;
}

.table .top .item .right {
  width: 328px;
  text-align: center;
}

.table .table-list {
  display: flex;
  flex-wrap: wrap;
}

.table .table-list .item {
  width: 50%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  display: flex;
  justify-content: center;
}

.table .table-list .item:nth-child(2n) {
  border-right: 0;
}

.table .table-list .item:nth-last-child(2),
.table .table-list .item:last-child {
  border-bottom: 0;
}

.table .table-list .item .index {
  width: 40px;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10px;
}

.table .table-list .item .content {
  display: flex;
  flex-direction: column;
  .left {
    width: 250px;
    height: 250px;
    margin: 0 auto;
    border: 1px solid #ebeef5;
    margin-bottom: 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .right {
    display: flex;
    flex-direction: column;

    .title {
      font-size: 14px;
      margin-bottom: 10px;
    }

    .list {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      width: 225px;
      height: 32px;

      .name {
        width: 85px;
      }

      .value {
        width: 100%;
      }
    }
  }
}
.sku-attr {
  overflow: hidden;
  padding: 0 0 0 8px;
  .sku-name {
    margin: 0 32px 0 0;
    float: left;
    line-height: 37px;
  }
  .sku-detail {
    float: left;
    margin: 5px 0 0 0;
    width: calc(100% - 65px);
    line-height: 37px;
  }
}
.sku-color {
  margin: 0 8px 0 0;
  padding: 4px;
  border: 1px solid #aaaaaa;
  cursor: pointer;
}
.sku-size {
  margin: 0 8px 0 0;
  padding: 4px 8px;
  border: 1px solid #aaaaaa;
  cursor: pointer;
}
.is-select {
  border: 2px solid #0099e1;
}
.sku-price {
  font-size: 20px;
}
table.ship {
  border-collapse: collapse;
  td,
  th {
    border: 1px solid #cad9ea;
    color: #666;
    height: 30px;
  }
  thead th {
    background-color: #cce8eb;
    width: 100px;
  }
  tr:nth-child(odd) {
    background: #fff;
  }
  tr:nth-child(even) {
    background: #f5fafa;
  }
}

.weight {
  line-height: 28px;
}
.ship {
  td {
    padding: 4px;
  }

  td {
    min-width: 76px;
  }
}
</style>
